export interface EmployeeNameFields {
  firstName?: string | null;
  lastName?: string | null;
}

const alphabeticalNameCollator = new Intl.Collator("en", {
  sensitivity: "base",
  usage: "sort",
});

function buildSortableEmployeeName(employee: EmployeeNameFields): string {
  const firstName = (employee.firstName ?? "").trim();
  const lastName = (employee.lastName ?? "").trim();

  if (firstName && lastName) {
    return `${firstName} ${lastName}`;
  }

  return firstName || lastName || "";
}

/** Comparable string for sorting an employee table by first or last name (lowercase, trimmed). */
export function buildNameSortKey(
  employee: EmployeeNameFields,
  basis: "firstName" | "lastName" = "firstName"
): string {
  const firstName = (employee.firstName ?? "").trim().toLowerCase();
  const lastName = (employee.lastName ?? "").trim().toLowerCase();
  return basis === "lastName" ? `${lastName} ${firstName}` : `${firstName} ${lastName}`;
}

export function sortEmployeesByFullName<T extends EmployeeNameFields>(
  employees: readonly T[] = []
): T[] {
  const employeesCopy: T[] = [...employees];

  employeesCopy.sort((employeeA, employeeB) => {
    const nameA = buildSortableEmployeeName(employeeA);
    const nameB = buildSortableEmployeeName(employeeB);
    return alphabeticalNameCollator.compare(nameA, nameB);
  });

  return employeesCopy;
}
